(function () {
  const animateSelector = [
    'h1',
    'h2',
    'h3',
    'p',
    '.rte',
    'img',
    '.card',
    'product-card',
    '.product-card',
    '.resource-card',
    '.collection-card',
    '[class*="cp-"]',
    '[class*="creopack-"]',
  ].join(',');

  const excludedSelector = [
    'header',
    'footer',
    'dialog',
    'dialog-component',
    '.drawer',
    '.cart-drawer',
    'cart-drawer-component',
    '.predictive-search',
    'predictive-search-component',
    '.facets',
    '.mobile-facets',
    '.facets-block-wrapper',
    '.sticky-add-to-cart',
    'sticky-add-to-cart',
    '.shopify-section-header',
    '[data-cp-wishlist-toggle]',
    '[data-cp-wishlist-clear]',
    '[data-cp-wishlist-submit]',
    '[data-cp-remove]',
    '.cp-card-save-btn',
    '.cp-card-wishlist',
    '.product-card__wishlist',
    '.wishlist-btn',
    '.cp-header-wishlist',
    '.cp-wishlist-quote__item-note',
    '.cp-tech-specs',
    '#header-group',
    '#filters-drawer',
    '#quick-add-dialog',
    '#search-modal',
  ].join(',');

  const cardSelector = [
    '.card',
    'product-card',
    '.product-card',
    '.resource-card',
    '.collection-card',
  ].join(',');

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  function reveal(element) {
    element.classList.add('is-visible');
    observer?.unobserve(element);
  }

  function isExcluded(element) {
    if (!(element instanceof HTMLElement)) return true;
    if (element.closest(excludedSelector)) return true;
    if (element.closest('[hidden], [aria-hidden="true"]')) return true;
    if (element.matches('script, style, noscript, template, svg, path')) return true;
    if (element.classList.contains('cp-animate')) return true;

    const parentCard = element.parentElement?.closest(cardSelector);
    if (parentCard && parentCard !== element) return true;

    return false;
  }

  function collectCandidates(root) {
    const scope = root instanceof HTMLElement ? root : document;
    const main = document.getElementById('MainContent');
    const searchRoot = scope.matches?.('#MainContent') || main?.contains(scope) ? scope : main;

    if (!searchRoot) return [];

    return Array.from(searchRoot.querySelectorAll(animateSelector)).filter((element) => !isExcluded(element));
  }

  function init(root) {
    const candidates = collectCandidates(root);

    if (!candidates.length) return;

    if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
      candidates.forEach((element) => {
        element.classList.add('cp-animate', 'is-visible');
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) reveal(entry.target);
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.12,
        }
      );
    }

    candidates.forEach((element) => {
      element.classList.add('cp-animate');
      observer.observe(element);
    });
  }

  function revealAll() {
    document.querySelectorAll('.cp-animate').forEach((element) => {
      element.classList.add('is-visible');
      observer?.unobserve(element);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  prefersReducedMotion.addEventListener?.('change', (event) => {
    if (event.matches) revealAll();
  });
})();
